import settings from '../settings';
import $ from 'jquery';
import _ from 'lodash';
import nunjucks from 'nunjucks';
import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();
import moment   from 'moment';
import horsey from 'horsey';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';     // Image support
import ExportData from 'highcharts/modules/export-data';  // CSV/XLS support
Exporting(Highcharts);
ExportData(Highcharts);

export default class Competitors {

    constructor() {
        this.init();
    }

    init() {
        this.renderSearch();

        $('.row--competitors').each(function (index, value) {
            var heights = $('.inner', this).map(function () {
                return $(this).height();
            }).get(),
            maxHeight = Math.max.apply(null, heights);

            $('.inner', this).height(maxHeight);
        });
    }

    getUsername(query) {
        return $.getJSON('/competitors/search', {
            'q': query
        }).then(function (data) {
            return data;
        });
    }

    renderSearch() {
        if ($('.page--competitors-search').length) {
            let that = this;

            horsey(document.querySelector('#username'), {
                source (data, done) {
                    let usernames = that.getUsername(data.input);

                    usernames.done(function (data) {
                        done(null, [{
                            list: data
                        }]);
                    });
                },
                renderItem: function (li, suggestion) {
                    var image = '<img src="' + suggestion.profile_image_url + '"/> ';
                    li.innerHTML = '<div class="image">' + image + '</div>' + '<div class="details">' + '<p class="name">' + suggestion.name + '</p><p class="username">@' + suggestion.username + '</p></div>';
                },
                predictNextSearch (info) {
                    $('#user_id').val(info.selection.id);
                },
                getText: 'username',
                appendTo: document.querySelector('.sey-wrapper'),
                highlighter: false
            });
        }
    }
}
